// src/components/LandingPage/ChooseYourQuest.tsx
import { QuestCard } from "./types";
import { imgImageAiPoweredCustomerExperiencePlatform, svgPaths } from "./data";

type Props = {
  cards: QuestCard[];
};

export default function ChooseYourQuest({ cards }: Props) {
  return (
    <section id="quests" className="py-12 lg:py-20 bg-gradient-to-b from-white to-[#f9fafb]">
      <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
        <div>
          <h2 className="text-center font-ubuntu text-2xl sm:text-3xl lg:text-[48px] leading-tight font-normal text-[#171a22] mb-4 lg:mb-8">
            Choose Your Quest
          </h2>
          <p className="font-ubuntu text-center text-base mx-auto sm:text-lg lg:text-[24px] leading-relaxed font-light text-[#171a22] max-w-[867px] mb-10 lg:mb-16">
            Participants are free to choose any topic or idea statement that matches their interests and skills.
            The hackathon is open-ended, encouraging creative, impactful, and innovative solutions across any domain.
          </p>
        </div>

        {/* Quest Cards */}
        <div className="font-ubuntu grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-8">
          {cards.map((card, idx) => (
            <div key={idx} className="bg-white rounded-[10px] shadow-lg overflow-hidden flex flex-col">
              <img
                src={imgImageAiPoweredCustomerExperiencePlatform}
                alt={card.title}
                className="w-full h-48 sm:h-56 lg:h-[320px] object-cover"
              />
              <div className="p-5 lg:p-8 flex flex-col flex-1">
                <h3 className="text-lg lg:text-[24px] leading-snug font-normal text-[#171a22] mb-3 lg:mb-4">{card.title}</h3>
                <p className="text-sm lg:text-[16px] leading-relaxed text-[#171a22] mb-4 lg:mb-6">{card.team}</p>

                <div className="border-b border-[#e5e7eb] pb-4 mb-4 mt-auto">
                  <div className="flex items-center gap-2 mb-3">
                    <svg className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 16 16">
                      <path d={svgPaths.p157d2d80} stroke="#1D365A" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.23" />
                    </svg>
                    <span className="text-sm font-semibold text-[#1d365a]">17/02/2026</span>
                  </div>
                  <div className="flex gap-2">
                    {card.timer.map((t, i) => (
                      <div key={i} className="bg-[#dbeafe] border border-[#bedbff] rounded-[10px] px-2 lg:px-3 py-2 text-center flex-1">
                        <div className="text-sm lg:text-base font-light text-[#0a0a0a]">{t.value}</div>
                        <div className="text-xs font-light text-[#0a0a0a]">{t.label}</div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex gap-3 lg:gap-4">
                  <button className="flex-1 border border-[#1d365a] rounded-full py-3 lg:py-4 text-xs lg:text-sm font-medium text-[#1d365a] hover:bg-[#1d365a] hover:text-white transition-colors">
                    View Details
                  </button>
                  <button className="flex-1 bg-[#18447c] rounded-full py-3 lg:py-4 text-xs lg:text-sm font-medium text-white hover:bg-opacity-90 transition-opacity flex items-center justify-center gap-1">
                    Register Now
                    <svg className="w-3 h-4" fill="none" viewBox="0 0 12.47 15.98">
                      <path d={svgPaths.p1ac706c0} stroke="#EEFBFF" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.13" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-between font-ubuntu">
          <span className="text-sm lg:text-base text-[#171a22]">1/12</span>
          <div className="flex gap-3 lg:gap-4">
            {[svgPaths.p3319a000, svgPaths.p2869500].map((path, i) => (
              <button
                key={i}
                className="w-10 h-10 lg:w-[42px] lg:h-[42px] border border-[#1d365a] rounded-full flex items-center justify-center hover:bg-[#1d365a] hover:text-white transition-colors"
              >
                <svg className="w-2 h-4" fill="none" viewBox="0 0 8.77 15.99">
                  <path d={path} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.55" />
                </svg>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
